<div class="container">

  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h2>Associação de Técnico</h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="associateAgentForm" *ngIf="!queryParams.serviceRequestId">
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="40" fxFlex.lt-md="100">
            <mat-label>Código da Solicitação</mat-label>
            <mat-select id="scheduleId" name="scheduleId" formControlName="scheduleId">
              <mat-option *ngFor="let serviceRequest of serviceRequests" [value]="serviceRequest.id">
                {{serviceRequest?.id}} - {{serviceRequest?.serviceLocalDescription}} </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="auto" fxFlex.lt-md="100">
            <mat-label>Técnico</mat-label>
            <mat-select id="agentId" name="agentId" formControlName="agentId">
              <mat-option *ngFor="let agent of agents" [value]="agent.id"> {{agent.name}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="end center" class="btn__register__container">
          <button mat-raised-button type="submit" color="primary" [disabled]="associateAgentForm.invalid"
            (click)="onSubmit()">
            Associar
          </button>
        </div>
      </form>

    </mat-card-content>
  </mat-card>

</div>
